import type { TextSizingConfigs } from './utils';
import { devices } from '../common/devices';
import { colors, darkThemeSelector, styled } from '../stitches.config';
import { Text } from './Text';

const titleVars = {
  touch: {
    size: 28,
    lineHeight: 36,
  },
  mouse: {
    size: 24,
    lineHeight: 32,
  },
} as const satisfies TextSizingConfigs;

const TitleBase = {
  color: colors.headingNeutralLight,
  [darkThemeSelector]: {
    color: colors.headingNeutralDark,
  },
};

export const TitleSansSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${titleVars.touch.size}`,
      lineHeight: `$${titleVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${titleVars.mouse.size}`,
      lineHeight: `$${titleVars.mouse.lineHeight}`,
    },
  },
};

export const TitleMonoSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${titleVars.touch.size - 2}`,
      lineHeight: `$${titleVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${titleVars.mouse.size - 2}`,
      lineHeight: `$${titleVars.mouse.lineHeight}`,
    },
  },
};

export const Title = styled(Text, TitleBase, {
  variants: {
    context: {
      body: {},
      heading: {},
    },
    family: {
      brand: TitleSansSizes,
      monospace: TitleMonoSizes,
    },
    weight: {
      bold: {},
    },
  },
  defaultVariants: {
    context: 'body',
    family: 'brand',
    weight: 'bold',
  },
});
Title.displayName = 'Title';
